import { Container, Box } from "@mui/material";
import React from "react";
import OptionsTab from "./OptionsTab";
import { SectionTitleSec, WhiteSection } from "../../styles/HomeStyles";

const OurJobs = ({ ...props }) => {
  return (
    <WhiteSection>
      <Container {...props}>
        <SectionTitleSec align="center" sx={{ marginBottom: "30px" }}>
          Nos Métiers
        </SectionTitleSec>
        <OptionsTab />
      </Container>
    </WhiteSection>
  );
};

export default OurJobs;
